import post from '../../../api/requests/post'

export default function weblog (msg) {
    try {
        const d = {
            message: msg,
        };
            post('', d);
        } catch (e) {
        console.log('Weblog display log error: ', e);
    }
}

export function initWeblog () {
    window.weblog = weblog;   
}
